import { QRCode } from 'antd'
import React from 'react'

function Xiaofeng() {
    return (
        <div style={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#f5f5f5',
            padding: '20px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                maxWidth: '100%',
                margin: '0 auto',
                backgroundColor: '#fff',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <h2 style={{
                    textAlign: 'center',
                    marginBottom: '20px',
                    color: '#333',
                    fontSize: '18px'
                }}>
                    三峡晓峰研学基地
                </h2>
                
                <div style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '100%',
                    margin: '0 auto'
                }}>
                    <video
                        controls
                        style={{
                            width: '100%',
                            height: 'auto',
                            borderRadius: '8px',
                            outline: 'none'
                        }}
                        preload="metadata"
                        poster=""
                    >
                        <source 
                            src="http://dianshangtaizhang.zzddww.com/assets/images/application/1761210221_6a6228a22f1649bb0c47.mp4" 
                            type="video/mp4"
                        />
                        您的浏览器不支持视频播放。
                    </video>
                </div>
                
                <div style={{
                    marginTop: '20px',
                    color: '#666',
                    fontSize: '14px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    <p>点击播放按钮开始观看演示视频</p>
                    <a href="https://www.bnsrj.com" target="_blank" rel="noreferrer" style={{marginTop: '20px'}}>技术支持：伯纳思软件</a>
                    <div style={{marginTop: '20px'}}>
                        <QRCode value="https://www.bnsrj.com/Xiaofeng" size={200} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Xiaofeng